import {axiosInstance} from "@/api/axiosInstance";


export const credentialsService = {
    // Get current credentials
    getCredentials: async () => {
        const response = await axiosInstance.get(`/api/general-credentials/get-credentials`);
        return response.data;
    },
    // Get public credentials (for PDF generation)
    getPublicCredentials: async () => {
        const response = await axiosInstance.get(`/public/get-credentials`);
        return response.data;
    },
    // Update credentials
    updateCredentials: async (data) => {
        const response = await axiosInstance.put(`/api/general-credentials/update`, data);
        return response.data;
    }
};
